<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="formCnt">
            
                    <v-card class="mx-auto elevation-4 pa-3" max-width="800" outlined>
                     
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Surname</label>
                                            <input disabled v-model="surname" type="text" class="formInp" placeholder="Surname">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">First Name</label>
                                            <input disabled v-model="name" type="text" class="formInp" placeholder="First Name">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Contact/Phone
                                                number</label>
                                            <input disabled v-model="phone" type="text" class="formInp"
                                                placeholder="Contact Phone No">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Residential
                                                Address</label>
                                            <input disabled v-model="residentialA" type="text" class="formInp"
                                                placeholder="Residential Address">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-1">
                                <div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexChec"
                                        >
                                        <label class="form-check-label">
                                            Male
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-1">
                                <div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexChec"
                                        >
                                        <label class="form-check-label">
                                            Female
                                        </label>
                                    </div>
                                </div>
                            </div> -->
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">Gender</label>
                                <v-select disabled v-model="gender" :items="genders" label="Gender" solo></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">Date of Birth</label>
                                <div data-app>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-menu v-model="dateModal" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field disabled v-model="date1" prepend-icon="mdi-calendar" readonly
                                                        v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker v-model="date1" @input="menu2 = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-2 col-lg-12">
                                <label class="text">Place of Birth</label>
                                <input disabled v-model="placeofBirth" type="email" class="formInp" placeholder="Place of Birth">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">ID Type</label>
                                <v-select disabled v-model="idType" :items="Idtypes" label="ID Type" solo></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="text">ID Number</label>
                                <input disabled v-model="idnumber" type="text" class="formInp" placeholder="ID Number">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Nationality</label>
                                            <input disabled type="text" v-model="nationality" class="formInp"
                                                placeholder="Nationality">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <label class="text">Mother's Maiden
                                                Name</label>
                                            <input disabled v-model="motherName" type="text" class="formInp"
                                                placeholder="Mother's Maiden Name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-lg-12">
                                <button @click="openSecond" class="btnNXT">Next </button>
                            </div>
                        </div> -->
                    </v-card>
                </div>
            </div>
        </div>

        <!-- SECOND ROW -->
        <div class="row">
            <v-card class="col-lg-9 mx-auto elevation-4 pa-3" max-width="800" outlined>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Business Name</label>
                                <input disabled v-model="businessName" type="text" class="formInp" placeholder="Business Name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Business Address</label>
                                <input disabled v-model="businessAddress" type="text" class="formInp"
                                    placeholder="Business Address">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">City/Town</label>
                                <input disabled v-model="city" type="text" class="formInp" placeholder="City/Town">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">State</label>
                                <input disabled v-model="state" type="text" class="formInp" placeholder="State">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Ward</label>
                                <input disabled v-model="ward" type="text" class="formInp" placeholder="Ward">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">LGA</label>
                                <input disabled v-model="lga" type="text" class="formInp" placeholder="LGA">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Company Registration No</label>
                                <input disabled v-model="compReg" type="text" class="formInp"
                                    placeholder="Company Registration No">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Agent's Mobile Number</label>
                                <input disabled v-model="agenMobile" type="text" class="formInp"
                                    placeholder="Agent's Mobile Number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="text">Type of Agent</label>
                            <v-select disabled v-model="agentType" :items="agentTypes" label="Agent Type" solo></v-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Bank Name</label>
                                <input disabled v-model="bankName" type="text" class="formInp" placeholder="Bank Name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Bank Verification No (BVN)</label>
                                <input disabled v-model="bvn" type="text" class="formInp"
                                    placeholder="Bank Verification No (BVN)">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Account Number</label>
                                <input disabled v-model="accNo" type="text" class="formInp" placeholder="Account Number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="text">Account Type</label>
                            <v-select disabled v-model="accType" :items="accTypes" label="Agent Type" solo></v-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Email Address</label>
                                <input disabled v-model="agntEmail" type="email" class="formInp" placeholder="Email Address">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Agent Name & Signature</label>
                                <input disabled type="text" class="signature" placeholder="Agent Name & Signature">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Date</label>
                                <div data-app>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-menu v-model="dateModal2" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field disabled v-model="date2" prepend-icon="mdi-calendar" readonly
                                                        v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-lg-12">
                            <button @click="openthird" class="btnNXT">Next </button>
                        </div>
                    </div> -->
                </div>
            </v-card>
        </div>
        <!-- THIRD ROW -->
        <div class="row">
            <v-card class="col-lg-9 mx-auto elevation-4 mt-3 pa-3" max-width="800" outlined>
                <p style="text-align: left"><strong>To be filled by the Guarantor:</strong>.</p>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Full Name</label>
                                <input disabled v-model="gFullname" type="text" class="formInp" placeholder="Full Name">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Residential Address</label>
                                <input disabled v-model="gresident" type="text" class="formInp"
                                    placeholder="Residential Address">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Mobile Number</label>
                                <input disabled v-model="gmobile" type="text" class="formInp" placeholder="Mobile Number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Email Addrsss</label>
                                <input disabled v-model="gemail" type="text" class="formInp" placeholder="Email Addrsss">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Relationship</label>
                                <input disabled v-model="gRelation" type="text" class="formInp" placeholder="Relationship">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <label class="text">Signature & Date</label>
                                <input disabled type="text" class="signature" placeholder="Signature & Date">
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-lg-12">
                            <button @click="openUpload" class="btnNXT">Next </button>
                        </div>
                    </div> -->
                </div>
            </v-card>
        </div>

        <!-- OFFFICIAL USE -->
        <!-- <div v-if="officialRow" class="row">
            <v-card class="mx-auto elevation-4 mt-3 pa-3" max-width="600" outlined>
                <div class="row">
                    <div class="col-lg-12">
                        <v-data-table hide-default-footer :headers="headers" :items="desserts" :items-per-page="5"
                            class="elevation-1">
                            <template v-slot:[`item.tick`]="{  }">
                                <v-checkbox v-model="checkbox"></v-checkbox>
                            </template>
                        </v-data-table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <label class="text">Approved by</label>
                                    <input type="text" class="formInp" placeholder="Approved by">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <label class="text">Name</label>
                                    <input type="text" class="formInp" placeholder="Name">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <button @click="saveAgent" class="btnNXT">Submit </button>
                    </div>
                </div>
            </v-card>
        </div> -->
        <div class="row">
            <v-card class="col-lg-9 mx-auto elevation-4 mt-3 pa-3" max-width="800" outlined>
                <div class="row">
                    <strong class="pa-3">Passport</strong>
                    <div class="col-lg-12">
                        <v-avatar size="100">
                            <img :src="image" alt="John">
                        </v-avatar>
                    </div>
                </div>
                <div class="row">
                    <strong class="pa-3">Identification Crediental</strong>
                    <div class="col-lg-12">
                     <img :src="govIdCard" alt="" srcset="" width="300">
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-lg-12">
                        <button @click="saveAgent" class="btnNXT">Submit </button>
                    </div>
                </div> -->
            </v-card>
        </div>
    </div>
</template>

<script>
// import axios from "axios"
import Swal from 'sweetalert2'

export default {
    data: () => ({
        genders: ['Male', 'Female'],
        Idtypes: ['Passport', 'Driver Liscence', 'National ID', 'Vater Card'],
        agentTypes: ['Aggregator', 'Agent'],
        accTypes: ['Savings', 'Current'],
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        modal: false,
        dateModal: false,
        dateModal2: false,
        secondRow: false,
        thirdRow: false,
        uplaoads: false,
        officialRow: false,
        checkbox: true,

        // FORM FIELDS
        surname: '',
        name: '',
        phone: '',
        residentialA: '',
        gender: '',
        idType: '',
        accType: '',
        agentType: '',
        image: '',
        govIdCard: '',
        placeofBirth: '',
        // Passport: '',
        // liscence: '',
        // nationalId: '',
        nationality: '',
        idnumber: '',
        // vcard: '',
        motherName: '',

        // SecondRow
        businessName: '',
        businessAddress: '',
        city: '',
        state: '',
        ward: '',
        lga: '',
        compReg: '',
        agenMobile: '',
        // aggregator: '',
        // agent: '',
        bankName: '',
        bvn: '',
        accNo: '',
        // saving: '',
        // current: '',
        agntEmail: '',

        // Gurantor
        gFullname: '',
        gresident: '',
        gmobile: '',
        gemail: '',
        gRelation: '',


        headers: [
            {
                text: 'Aggent Registration Requirements',
                align: 'start',
                sortable: false,
                value: 'requirements',
            },
            { text: 'Aggregator', value: 'aggregator' },
            { text: 'Agent', value: 'agent' },
            { text: 'Tick', value: 'tick' },
        ],
        desserts: [
            {
                requirements: 'Certificate of Business Incorporative (If Any)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Memorandum and Article of Associaion (MEMART) (If Any)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Guarantors Official ID and Passport Photo',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Evidence of Existing Three months Bank Statement',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Proof of Address (Utility Bill or Rent Receipt)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Signed Legal Agency Aggreement Form',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Certificate of good conduct (court Affidavit, or A letter from AMMAN)',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: 'Endorsed Copies of Acceptable ID Cards',
                aggregator: '',
                agent: '',
                tick: '',
            },
            {
                requirements: '2 Passport Photograph',
                aggregator: '',
                agent: '',
                tick: '',
            },
        ],
    }),
    async mounted() {
        const agentInfo  = JSON.parse(atob(this.$route.params.agent))
        this.image = agentInfo.passport
                this.govIdCard = agentInfo.govId
                this.surname = agentInfo.surName
                this.name = agentInfo.firstName
                this.phone = agentInfo.phoneNo
                this.date1 = agentInfo.dateofBirth
                this.email = agentInfo.emailAdd
                this.residentialA = agentInfo.residentialAddress
                this.gender = agentInfo.gender
                this.placeofBirth = agentInfo.placeofBirth
                this.idType = agentInfo.idType
                this.nationality = agentInfo.nationality
                this.idnumber = agentInfo.idNumber
                this.motherName = agentInfo.motherName
                this.businessName = agentInfo.businessName
                this.businessAddress = agentInfo.businessAddress
                this.city = agentInfo.city
                this.state = agentInfo.state
                this.agntEmail = agentInfo.emailAdd
                this.ward = agentInfo.ward
                this.lga = agentInfo.lga
                this.compReg = agentInfo.compReg
                this.agenMobile = agentInfo.agentsNumber
                this.agentType = agentInfo.typeOfAgent
                this.bankName = agentInfo.bankName
                this.bvn = agentInfo.bankVn
                this.accNo = agentInfo.accountNo
                this.accType = agentInfo.accountType
                this.gFullname = agentInfo.gfullName
                this.gresident = agentInfo.greside
                this.gmobile = agentInfo.gnumber
                this.gemail = agentInfo.gEmail
                this.gRelation = agentInfo.relationship
        // await axios.all([
        //     axios.get('http://localhost:4000/api/v1/form/634c6d58e90ded0a80ed2216'),
        // ])
        //     .then(axios.spread((response1) => {
        //         this.request = response1.data.data.nbHits
        //         console.log(response1.data.data);
        //         this.image = response1.data.data.singleAgents.passport
        //         this.govIdCard = response1.data.data.singleAgents.govId
        //         this.surname = response1.data.data.singleAgents.surName
        //         this.name = response1.data.data.singleAgents.firstName
        //         this.phone = response1.data.data.singleAgents.phoneNo
        //         this.date1 = response1.data.data.singleAgents.dateofBirth
        //         this.email = response1.data.data.singleAgents.emailAdd
        //         this.residentialA = response1.data.data.singleAgents.residentialAddress
        //         this.gender = response1.data.data.singleAgents.gender
        //         this.placeofBirth = response1.data.data.singleAgents.placeofBirth
        //         this.idType = response1.data.data.singleAgents.idType
        //         this.nationality = response1.data.data.singleAgents.nationality
        //         this.idnumber = response1.data.data.singleAgents.idNumber
        //         this.motherName = response1.data.data.singleAgents.motherName
        //         this.businessName = response1.data.data.singleAgents.businessName
        //         this.businessAddress = response1.data.data.singleAgents.businessAddress
        //         this.city = response1.data.data.singleAgents.city
        //         this.state = response1.data.data.singleAgents.state
        //         this.agntEmail = response1.data.data.singleAgents.emailAdd
        //         this.ward = response1.data.data.singleAgents.ward
        //         this.lga = response1.data.data.singleAgents.lga
        //         this.compReg = response1.data.data.singleAgents.compReg
        //         this.agenMobile = response1.data.data.singleAgents.agentsNumber
        //         this.agentType = response1.data.data.singleAgents.typeOfAgent
        //         this.bankName = response1.data.data.singleAgents.bankName
        //         this.bvn = response1.data.data.singleAgents.bankVn
        //         this.accNo = response1.data.data.singleAgents.accountNo
        //         this.accType = response1.data.data.singleAgents.accountType
        //         this.gFullname = response1.data.data.singleAgents.gfullName
        //         this.gresident = response1.data.data.singleAgents.greside
        //         this.gmobile = response1.data.data.singleAgents.gnumber
        //         this.gemail = response1.data.data.singleAgents.gEmail
        //         this.gRelation = response1.data.data.singleAgents.relationship
               
        //     }))
        //     .catch(function (error) {
        //         console.log(error);
        //     });

    },
    methods: {
        uploadFile() {
            this.image = this.$refs.img.files[0];
            console.log(this.image);
        },
        uploadFile2() {
            this.image = this.$refs.img2.files[0];
            console.log(this.image);
        },
        openSecond() {
            if (this.motherName === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please Complete the form!',
                    width: 400,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                this.secondRow = true
            }
        },
        openthird() {
            if (this.agntEmail === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please Complete the form!',
                    width: 400,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                this.thirdRow = true
            }
        },
        openofficial() {
            this.officialRow = true
        },
        openUpload() {
            if (this.gFullname === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please Complete the form!',
                    width: 400,
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                this.uplaoads = true
            }
        },
        // async saveAgent() {
        //     const formData = new FormData();

        //     formData.append('passport', this.image);
        //     formData.append('govId', this.govIdCard);
        //     formData.append('surName', this.surname)
        //     formData.append('firstName', this.name)
        //     formData.append('phoneNo', this.phone)
        //     formData.append('residentialAddress', this.residentialA)
        //     formData.append('idNumber', this.idnumber)
        //     formData.append('gender', this.gender)
        //     formData.append('dateofBirth', this.date1)
        //     formData.append('placeofBirth', this.placeofBirth)
        //     formData.append('idType', this.idType)
        //     formData.append('nationality', this.nationality)
        //     formData.append('motherName', this.motherName)
        //     formData.append('businessName', this.businessName)
        //     formData.append('businessAddress', this.businessAddress)
        //     formData.append('city', this.city)
        //     formData.append('state', this.state)
        //     formData.append('emailAdd', this.agntEmail)
        //     formData.append('ward', this.ward)
        //     formData.append('lga', this.lga)
        //     formData.append('compReg', this.compReg)
        //     formData.append('agentsNumber', this.agenMobile)
        //     formData.append('typeOfAgent', this.agentType)
        //     formData.append('bankName', this.bankName)
        //     formData.append('bankVn', this.bvn)
        //     formData.append('accountNo', this.accNo)
        //     formData.append('accountType', this.accType)
        //     formData.append('gfullName', this.gFullname)
        //     formData.append('greside', this.gresident)
        //     formData.append('gnumber', this.gmobile)
        //     formData.append('gEmail', this.gemail)
        //     formData.append('relationship', this.gRelation)
        //     await axios.post(`http://localhost:4000/api/v1/form`, formData)
        //         .then((response) => {
        //             console.log(response);
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //         })
        // }
    }
}
</script>

<style lang="scss" scoped>
.formInp {
    background: #FFFFFF;
    border: 1px solid #DFDFDF;
    border-radius: 3px;
    width: 100%;
    height: 45px;
    padding: 0 10px;

    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    text-align: left;
    color: #4F4F4F;

}

.signature {
    // background: #FFFFFF;
    border-bottom: 1px solid #DFDFDF;
    border-radius: 3px;
    width: 100%;
    height: 45px;
    padding: 0 10px;

    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    text-align: left;
    color: #4F4F4F;

}

.btnNXT {
    width: 177px;
    height: 49px;
    background: #21618C;
    border-radius: 5px;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
}

.formCnt {
    width: 100%;
    // height: 100vh;

    .LogoName {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        width: 100%;
    }

}

.agnt {
    font-size: 2rem;
    margin-left: 1rem;
}

.instruct {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 110%;
    color: #4F4F4F;
}

.text {
    text-align: left;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    color: #4F4F4F;
}
</style>